import { RecordUtils } from "andculturecode-javascript-core";
import { Record } from "immutable";
import { GroupUser } from "models/interfaces/groups/group-user";
import { GroupRecord } from "./group-record";
import { UserRecord } from "../users/user-record";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: GroupUser = {
    createdById: undefined,
    createdOn: undefined,
    updatedById: undefined,
    updatedOn: undefined,
    deletedById: undefined,
    deletedOn: undefined,
    id: undefined,
    groupId: 0,
    userId: 0,
    group: undefined,
    user: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class GroupUserRecord extends Record(defaultValues) implements GroupUser {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<GroupUser>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.group != null) {
            params.group = RecordUtils.ensureRecord(params.group, GroupRecord);
        }

        if (params.user != null) {
            params.user = RecordUtils.ensureRecord(params.user, UserRecord);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    public with(values: Partial<GroupUser>): GroupUserRecord {
        return new GroupUserRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// #endregion Record

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { GroupUserRecord };

// #endregion Exports
